"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Settings/Notice.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _app = require('shared/selectors/app');
var _app3 = require('web/services/app');
var _hooks = require('web/services/hooks');

var _Notice = require('web/components/Settings/Notice'); var _Notice2 = _interopRequireDefault(_Notice);





const Notice = ({ className }) => {
  const isAppOutdated = _hooks.useAppSelector.call(void 0, _app.selectIsAppOutdated)

  return (
    _react2.default.createElement(_Notice2.default, {
      className: className,
      isAppOutdated: isAppOutdated,
      onUpdate: _app3.updateApp, __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
    )
  )
}

exports. default = _react.memo.call(void 0, Notice)
